import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SpaceAccountTemplateModelData } from "@/store/templates/types";
import { WithAppStore } from "@/store/types";
import { Uuid } from "@/domains/global/identifiers";
import { makeObservable, observable } from "mobx";

export class SpaceAccountTemplateObservable extends BaseSyncModel<SpaceAccountTemplateModelData> {
  public modelKind = SyncModelKind.SpaceAccountTemplate;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<SpaceAccountTemplateModelData> } & WithAppStore) {
    super({ id, data, store });
    makeObservable(this, { modelKind: observable });
  }
}
